import * as types from './ActionTypes';

export const setLang = lang => ({
  type: types.SET_LANGUAGE,
  payload: lang
})

export const setSDK = value => ({
  type: types.SET_SDK,
  payload: value
})
